import { Fragment } from "react";

import { ApplicationCard } from "@/components/molecules/ApplicationCard";
import ApplicationListSkeleton from "@/components/molecules/ApplicationsList/applicationsListSkeleton";
import EmptyStateApplications from "@/components/molecules/ApplicationsList/emptyStateApplicationsList";
import type { IApplicationListProps } from "@/components/molecules/ApplicationsList/types";

const ApplicationsList = ({
  applications,
  emptyStateComponent,
  isLoadingApplications = false,
}: IApplicationListProps) => {
  if (isLoadingApplications) {
    return <ApplicationListSkeleton showTitleAndDescription={false} />;
  }

  return (
    <Fragment key="appList">
      {applications.length !== 0 ? (
        <div className="grid grid-cols-4 max-sm:grid-cols-1 max-md:grid-cols-2 max-lg:grid-cols-1 max-xl:grid-cols-2 max-xxl:grid-cols-3 gap-4 max-sm:gap-0">
          {applications.map((application, index) => (
            <ApplicationCard key={index} application={application} />
          ))}
        </div>
      ) : (
        emptyStateComponent || <EmptyStateApplications />
      )}
    </Fragment>
  );
};

export default ApplicationsList;
